import { create } from 'zustand'

interface ChatWidgetStore {
  open: boolean
  setOpen: (open: boolean) => void
  toggle: () => void
}

export const useChatWidgetStore = create<ChatWidgetStore>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
  toggle: () => set((s) => ({ open: !s.open })),
}))
